<script>
    import {fade} from 'svelte/transition';

    import I18n from '@js/modules/translations';

    import {mapStore} from '@js/stores/mapStore';

    import {applyRideType} from '@js/actions/mapActions';

    import Icon from '@js/components/themes/Icon.svelte';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    const _handleSelect = (rideType) => {
        if (rideType === mapStore.currentRideType) {
            return;
        }

        applyRideType(rideType);
    };

    const MAX_VISIBLE_WAYPOINTS = 5;
    const isSelectorVisible = $derived.by(() => {
        const waypoints = ($mapStore.map?._mapModel?.linePoints || []).filter((point) => !point.computed);
        return waypoints.length <= MAX_VISIBLE_WAYPOINTS;
    });
</script>

{#if isSelectorVisible}
    <div id="route-type-bar"
         class="map-route-type-bar"
         transition:fade={{duration: 200}}>
        <span class="map-route-type-bar-label">
            {I18n.t('js.maps.route_type_bar.label')}
        </span>

        <div class="map-route-type-bar-options">
            {#each Object.keys(RIDE_TYPE_ICON) as rideType (rideType)}
                <!-- The label span is hidden at small widths, leaving the icon alone:
                     name the button itself so it stays announceable. -->
                <button type="button"
                        aria-label={I18n.t(`js.ride.enums.ride_type.${rideType}`)}
                        class="map-route-type-bar-option"
                        class:map-route-type-bar-option-active={$mapStore.currentRideType === rideType}
                        aria-pressed={$mapStore.currentRideType === rideType}
                        onclick={() => _handleSelect(rideType)}>
                    <Icon class="h-4 w-4"
                          icon={RIDE_TYPE_ICON[rideType]}/>
                    <span class="map-route-type-bar-option-label">
                        {I18n.t(`js.ride.enums.ride_type.${rideType}`)}
                    </span>
                </button>
            {/each}
        </div>
    </div>
{/if}
